var _rect, _path, _g, _g2, _path2, _path3, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1928_275423",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1928_275423)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1928_275423)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1928_275423",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 17,
    width: 94,
    height: 105
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.322 109.143C114.322 115.739 108.974 121.087 102.378 121.087H33.2459C26.6494 121.087 21.3018 115.739 21.3018 109.143V59.0904C21.3018 55.6059 22.8234 52.2951 25.4678 50.026L60.0337 20.3653C64.5083 16.5256 71.1153 16.5256 75.5899 20.3653L110.156 50.026C112.8 52.2951 114.322 55.6059 114.322 59.0904V109.143Z",
    fill: "url(#paint0_linear_1928_275423)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1928_275423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -17.1924,
    y: 166.254,
    width: 175.97,
    height: 176.726,
    rx: 5.44794,
    transform: "rotate(-90 -17.1924 166.254)",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_f_1928_275423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 157.934,
    cy: 56.9979,
    r: 80.3985,
    fill: "#0078D4"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1928_275423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.901 155.723C192.277 173.405 155.883 178.196 121.726 169.044C87.5686 159.891 58.4462 137.545 40.7652 106.92C23.0841 76.2958 18.2928 39.9019 27.4451 5.74472C36.5975 -28.4124 58.9439 -57.5348 89.5684 -75.2159L156.235 40.2538L222.901 155.723Z",
    fill: "#9FD2F9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1928_275423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 129.605,
    cy: 100.567,
    r: 85.377,
    fill: "#49C5B1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1928_275423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108.179,
    cy: 127.559,
    r: 81.8563,
    fill: "#0078D4"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1928_275423)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.917,
    cy: -17.6918,
    rx: 92.139,
    ry: 52.7366,
    transform: "rotate(-30 163.917 -17.6918)",
    fill: "#C8F7FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1928_275423)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.733,
    cy: 137.535,
    rx: 51.3435,
    ry: 26.6986,
    transform: "rotate(22.7278 145.733 137.535)",
    fill: "#00487F"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_1928_275423)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.331 13.4297C66.6554 11.5129 70.0157 11.5247 72.3265 13.4578L121.67 54.7371C124.32 56.9543 124.672 60.9003 122.454 63.5508C120.237 66.2012 116.291 66.5523 113.641 64.3351L68.2832 26.3905L22.2379 64.3632C19.5719 66.5617 15.6285 66.1828 13.4299 63.5169C11.2313 60.8509 11.6102 56.9075 14.2762 54.7089L64.331 13.4297Z",
    fill: "url(#paint1_linear_1928_275423)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.331 110.057C122.91 100.26 114.101 93 103.607 93C95.2941 93 88.0406 97.5548 84.1792 104.317C83.121 104.109 82.0283 103.999 80.9115 103.999C71.5711 103.999 64 111.611 64 121.001C64 130.39 71.5711 138 80.9115 138C81.015 138 81.1203 138 81.2239 137.997V138H124.001C124.025 138 124.049 138 124.073 138C131.765 138 138 131.733 138 124.001C138 116.696 132.433 110.695 125.33 110.057H125.331Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1928_275423",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 93,
    width: 74,
    height: 45
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.331 110.057C122.91 100.26 114.101 93 103.607 93C95.2941 93 88.0406 97.5548 84.1792 104.317C83.121 104.109 82.0283 103.999 80.9115 103.999C71.5711 103.999 64 111.611 64 121.001C64 130.39 71.5711 138 80.9115 138C81.015 138 81.1203 138 81.2239 137.997V138H124.001C124.025 138 124.049 138 124.073 138C131.765 138 138 131.733 138 124.001C138 116.696 132.433 110.695 125.33 110.057H125.331Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1928_275423)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1928_275423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.67 107.315C113.67 114.655 107.72 120.605 100.38 120.605H34.9296C27.5898 120.605 21.6396 114.655 21.6396 107.315V58.9337C21.6396 55.0892 23.3045 51.433 26.2045 48.909L58.9297 20.4261C63.9318 16.0724 71.3779 16.0724 76.3801 20.4261L109.105 48.909C112.005 51.433 113.67 55.0892 113.67 58.9337V107.315Z",
    fill: "url(#paint2_linear_1928_275423)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_iii_1928_275423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.331 110.057C122.91 100.26 114.101 93 103.607 93C95.2941 93 88.0406 97.5548 84.1792 104.317C83.121 104.109 82.0283 103.999 80.9115 103.999C71.5711 103.999 64 111.611 64 121.001C64 130.39 71.5711 138 80.9115 138C81.015 138 81.1203 138 81.2239 137.997V138H124.001C124.025 138 124.049 138 124.073 138C131.765 138 138 131.733 138 124.001C138 116.696 132.433 110.695 125.33 110.057H125.331Z",
    fill: "#8DC8E8",
    fillOpacity: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_diiii_1928_275423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8859 96.2435L74.2777 50.9524C74.9804 49.3105 76.8814 48.5494 78.5236 49.2523C80.0481 49.9052 80.8133 51.5909 80.3521 53.143L80.2234 53.4982L60.8318 98.7894C60.1288 100.431 58.2279 101.192 56.5859 100.49C55.0613 99.8366 54.2961 98.151 54.7574 96.5986L54.8859 96.2435ZM36.1523 72.5766L49.0884 59.6406C50.3514 58.3777 52.3991 58.3777 53.662 59.6406C54.8279 60.8064 54.9175 62.6409 53.9311 63.9096L53.662 64.2142L43.0127 74.8637L53.662 85.5127C54.925 86.7759 54.925 88.8234 53.662 90.0866C52.4962 91.2521 50.6618 91.342 49.3931 90.3557L49.0884 90.0866L36.1523 77.1505C34.9865 75.9846 34.8968 74.1499 35.8833 72.8816L36.1523 72.5766ZM81.4262 59.6366C82.592 58.4708 84.4264 58.3813 85.6951 59.3678L85.9997 59.6368L98.9384 72.5769C100.105 73.7431 100.194 75.5787 99.2062 76.8471L98.9368 77.1518L85.9981 90.0737C84.7343 91.3356 82.6865 91.3343 81.4245 90.0704C80.2593 88.9039 80.171 87.0692 81.1584 85.8015L81.4275 85.4969L92.0768 74.8621L81.4258 64.2102C80.163 62.9472 80.163 60.8995 81.4262 59.6366Z",
    fill: "url(#paint3_linear_1928_275423)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1928_275423",
    x: 21.3018,
    y: 15.98,
    width: 93.3969,
    height: 105.86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.50557
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_1928_275423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376393,
    dy: 0.752787
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_1928_275423",
    result: "effect2_innerShadow_1928_275423"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1928_275423",
    x: 36.8921,
    y: -64.0437,
    width: 242.083,
    height: 242.083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.3215,
    result: "effect1_foregroundBlur_1928_275423"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1928_275423",
    x: -17.7417,
    y: -115.859,
    width: 281.286,
    height: 330.089,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.3215,
    result: "effect1_foregroundBlur_1928_275423"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1928_275423",
    x: 3.58545,
    y: -25.4526,
    width: 252.04,
    height: 252.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.3215,
    result: "effect1_foregroundBlur_1928_275423"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1928_275423",
    x: -14.3208,
    y: 5.06005,
    width: 244.999,
    height: 244.999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.3215,
    result: "effect1_foregroundBlur_1928_275423"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1928_275423",
    x: 39.2124,
    y: -123.206,
    width: 249.409,
    height: 211.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.3215,
    result: "effect1_foregroundBlur_1928_275423"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1928_275423",
    x: 56.6128,
    y: 65.2693,
    width: 178.24,
    height: 144.531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.3215,
    result: "effect1_foregroundBlur_1928_275423"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_1928_275423",
    x: 12,
    y: 10.4944,
    width: 112.289,
    height: 56.0513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.50557
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_1928_275423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376393,
    dy: 0.752787
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_1928_275423",
    result: "effect2_innerShadow_1928_275423"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1928_275423",
    x: 14.6396,
    y: 10.1609,
    width: 106.03,
    height: 117.444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1928_275423"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_iii_1928_275423",
    x: 62.4228,
    y: 91.4228,
    width: 75.5772,
    height: 47.5812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.004
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.00801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-dodge",
    in2: "shape",
    result: "effect1_innerShadow_1928_275423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.56075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "effect1_innerShadow_1928_275423",
    result: "effect2_innerShadow_1928_275423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.57723,
    dy: -1.57723
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.29555 0 0 0 0 0.575 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect2_innerShadow_1928_275423",
    result: "effect3_innerShadow_1928_275423"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_diiii_1928_275423",
    x: 31.4429,
    y: 47.4856,
    width: 72.2049,
    height: 60.7899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.76214
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88107
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1928_275423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1928_275423",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.376214,
    dy: -0.752427
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.752427
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1928_275423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376214,
    dy: 0.752427
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.752427
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1928_275423",
    result: "effect3_innerShadow_1928_275423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376214,
    dy: 0.752427
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88107
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_1928_275423",
    result: "effect4_innerShadow_1928_275423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.50485
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88107
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_1928_275423",
    result: "effect5_innerShadow_1928_275423"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1928_275423",
    x1: 114.322,
    y1: 61.0715,
    x2: 21.3018,
    y2: 61.0715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#51E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1928_275423",
    x1: 43.5882,
    y1: 5.20794,
    x2: 88.3002,
    y2: 88.8875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445972,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895626,
    stopColor: "#2A446F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1928_275423",
    x1: 76.4343,
    y1: 77.8582,
    x2: 165.439,
    y2: 123.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445972,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895626,
    stopColor: "#2A446F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1928_275423",
    x1: 48.5286,
    y1: 18.4386,
    x2: 133.57,
    y2: 80.6006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F0F7"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Home.e807ecd0f1051480fc189a7ece636bb0.svg";